export type Testimonial = {
  quote: string
  author: string
  role: string
  avatar?: string
}

export type CoachProfile = {
  name: string
  role: string
  bio: string
}

/**
 * Only real reviews from real coaches (with their permission).
 * The review sections only render when these arrays have items.
 */
export const coachProfiles: CoachProfile[] = [
  {
    name: 'Emily Carter',
    role: 'Recreational Gymnastics Coach · Manchester, UK',
    bio: 'I’ve coached recreational gymnastics for 11 years, working with children aged 3–12 across mixed-ability classes. I’ve planned and delivered hundreds of recreational sessions across floor, bars, beam and vault.',
  },
  {
    name: 'Sarah Mitchell',
    role: 'Rec Program Director · Toronto, Canada',
    bio: 'I’ve spent 9 years coaching recreational gymnastics and developing lesson structures for mixed-age and mixed-ability groups. My focus has always been making sessions practical for coaches to deliver, not just lists of skills.',
  },
]

export const shortTestimonials: Testimonial[] = [
  {
    quote:
      'I was spending hours putting together my weekly classes, and half the time they still felt improvised once the kids arrived. The Class-Ready plans gave me an actual structure I could walk in and teach.',
    author: 'Rachel Thompson',
    role: 'Recreational Gymnastics Coach · Sydney, Australia',
  },
  {
    quote:
      'My groups rarely have everyone working at the same level. The progression ladders made it much easier to give the same skill to different gymnasts without having to create separate lessons.',
    author: 'Lauren Smith',
    role: 'Recreational Coach · California, USA',
  },
  {
    quote:
      'I noticed the gymnasts were moving through skills more confidently because we weren’t jumping straight to the hardest version. They had a clear next step every week.',
    author: 'Emma Davis',
    role: 'Recreational Coach · Texas, USA',
  },
]

export const moreTestimonials: Testimonial[] = [
  {
    quote: 'I pick the week, print the plan and know what I’m teaching.',
    author: 'Amanda',
    role: 'Rec Coach · USA',
  },
]

/**
 * Real words from rec gymnastics coaches on a public coaching forum (ChalkBucket).
 * They describe the problem, they are NOT reviews of this product.
 */
export type ForumQuote = { quote: string; context: string }

export const forumQuotes: ForumQuote[] = [
  {
    quote:
      '…somehow every week turns into a free-for-all and you can’t tell that I spent about 5 hours planning our class at all.',
    context: 'Rec coach · coaching forum, 2024',
  },
  {
    quote:
      'If I take the time to correct anything or work with a student for even a moment, all control is lost.',
    context: 'Rec coach · coaching forum, 2024',
  },
  {
    quote: 'the rec program’s are getting a little bit old…Even the head coach is running out of ideas',
    context: 'Gym coach · coaching forum, 2014',
  },
]
